export function routing($stateProvider) {
  $stateProvider.state('index.customercare.customer.customPage', {
    url: '/customPage/:pageId',
    template: '<custom-page-contextual></custom-page-contextual>'
  });
}